import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-inteligence',
  templateUrl: './business-inteligence.component.html',
  styleUrls: ['./business-inteligence.component.scss']
})
export class BusinessInteligenceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
